module.exports = __webpack_public_path__ + "img/Thumbnail_vod.3e75a5ed.png";